module.exports = __webpack_public_path__ + "img/img-2-3mobile.58df2846.png";